module.exports = "<div class=\"svg-icons-wrp svg-icons-wrp_add\"> <svg class=\"svg-icons svg-icons_plus\"><use xlink:href=#icon-plus /> </svg> </div> {{localize 'CORE.FORM.EDITORS.REFERENCE.ADDNEW'}}";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/reference/templates/addNewButton.hbs
// module id = 674
// module chunks = 0